<template>
  <div class="tech-catalog">
    <section v-for="category in categories" :key="category.name" class="catalog-section" :aria-label="category.name + ' technologies'">
      <header class="catalog-heading"><h2>{{ category.name }}</h2><span>{{ category.description }}</span></header>
      <div class="catalog-grid">
        <article v-for="tech in techs.slice(category.start, category.end)" :key="tech.name" class="catalog-app">
          <div class="catalog-icon"><i v-if="tech.icon" :class="tech.icon" aria-hidden="true"></i><img v-else-if="!failedLogos[tech.name]" :src="tech.logo" alt="" loading="lazy" decoding="async" @error="$set(failedLogos, tech.name, true)"><span v-else aria-hidden="true">{{ tech.name.slice(0, 2) }}</span></div>
          <div class="catalog-copy"><h3>{{ tech.name }}</h3><p>{{ category.description }}</p></div>
          <a :href="tech.link" target="_blank" rel="noopener noreferrer" class="catalog-visit" :aria-label="'Visit ' + tech.name + ' website'">Visit</a>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      failedLogos: {},
      techs: [
        {
          name: "JavaScript",
          logo: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
          link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
        },
        {
          name: "TypeScript",
          logo: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
          link: "https://www.typescriptlang.org/",
        },
        {
          name: "Bootstrap",
          logo: "https://www.svgrepo.com/show/353498/bootstrap.svg",
          link: "https://getbootstrap.com/",
        },
        {
          name: "Sass",
          logo: "https://banner2.cleanpng.com/20180420/pzw/kisspng-sass-cascading-style-sheets-preprocessor-less-post-meng-5adaa47ca100e3.1728846115242783966595.jpg",
          link: "https://sass-lang.com/",
        },
        {
          name: "Tailwind CSS",
          logo: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
          link: "https://tailwindcss.com/",
        },
        {
          name: "React.js",
          logo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
          link: "https://reactjs.org/",
        },
        {
          name: "Next.js",
          logo: "https://www.svgrepo.com/show/354113/nextjs-icon.svg",
          link: "https://nextjs.org/",
        },
        {
          name: "Vue.js",
          logo: "https://brandlogos.net/wp-content/uploads/2022/01/vue.js-logo-brandlogo.net_-512x512.png",
          link: "https://vuejs.org/",
        },
        {
          name: "Node.js",
          logo: "https://palinfocom.com/wp-content/uploads/2024/07/png-transparent-js-logo-node-logos-and-brands-icon-thumbnail.png",
          link: "https://nodejs.org/",
        },
        {
          name: "Express.js",
          logo: "https://img.icons8.com/color/512/express-js.png",
          link: "https://expressjs.com/",
        },
        {
          name: "Python",
          logo: "https://www.citypng.com/public/uploads/preview/hd-python-logo-symbol-transparent-png-735811696257415dbkifcuokn.png",
          link: "https://www.python.org/",
        },
        {
          name: "FastAPI",
          logo: "https://cdn.worldvectorlogo.com/logos/fastapi.svg",
          link: "https://fastapi.tiangolo.com/",
        },
        {
          name: "Ruby",
          logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4HIoxwDYBaTj83Ouyo79sJ5x9JtJYAXDuvQ&s",
          link: "https://www.ruby-lang.org/en/",
        },
        {
          name: "Ruby on Rails",
          logo: "https://upload.wikimedia.org/wikipedia/commons/6/62/Ruby_On_Rails_Logo.svg",
          link: "https://rubyonrails.org/",
        },
        {
          name: "RESTful API",
          logo: "https://media.lordicon.com/icons/wired/gradient/1330-rest-api.svg",
          link: "https://restfulapi.net/",
        },
        {
          name: "GraphQL",
          logo: "https://w7.pngwing.com/pngs/81/179/png-transparent-graphql-hd-logo-thumbnail.png",
          link: "https://graphql.org/",
        },
        {
          name: "SQL",
          icon: "fas fa-database",
          link: "https://www.w3schools.com/sql/",
        },
        {
          name: "PostgreSQL",
          logo: "https://brandlogos.net/wp-content/uploads/2021/11/postgresql-logo.png",
          link: "https://www.postgresql.org/",
        },
        {
          name: "MongoDB",
          logo: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
          link: "https://www.mongodb.com/",
        },
        {
          name: "Git",
          logo: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg",
          link: "https://git-scm.com/",
        },
        {
          name: "Vercel",
          logo: "https://static.wikia.nocookie.net/logopedia/images/a/a7/Vercel_favicon.svg",
          link: "https://vercel.com/",
        },
        {
          name: "AWS",
          logo: "https://meta-q.cdn.bubble.io/f1718125893082x625655806421663100/aws-app-icon.jpg",
          link: "https://aws.amazon.com/",
        },
        {
          name: "Azure",
          logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@v2.16.0/icons/azure/azure-original.svg",
          link: "https://azure.microsoft.com/",
        },
        {
          name: "Docker",
          logo: "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/97_Docker_logo_logos-512.png",
          link: "https://www.docker.com/",
        },
        {
          name: "Kubernetes",
          logo: "https://upload.wikimedia.org/wikipedia/commons/3/39/Kubernetes_logo_without_workmark.svg",
          link: "https://kubernetes.io/",
        },
        {
          name: "Terraform",
          logo: "https://img.icons8.com/?size=512&id=WncR8Bcg5nE9&format=png",
          link: "https://www.terraform.io/",
        },
        {
          name: "Figma",
          logo: "https://cdn4.iconfinder.com/data/icons/logos-brands-in-colors/3000/figma-logo-512.png",
          link: "https://www.figma.com/",
        },
      ],
      categories: [{"name": "Frontend", "description": "Interfaces & experiences", "start": 0, "end": 8}, {"name": "Backend", "description": "Services & APIs", "start": 8, "end": 16}, {"name": "Data", "description": "Databases & storage", "start": 16, "end": 19}, {"name": "Cloud & DevOps", "description": "Infrastructure & delivery", "start": 19, "end": 26}, {"name": "Design", "description": "Prototyping & collaboration", "start": 26, "end": 27}],
    };
  },
};
</script>

<style scoped>
.tech-catalog { margin-top: 30px; color: var(--bio-text); }
.catalog-section + .catalog-section { margin-top: 32px; }
.catalog-heading { border-top: 1px solid var(--bio-line); padding-top: 18px; margin-bottom: 12px; }
.catalog-heading h2 { margin: 0; font-size: 21px; letter-spacing: -.5px; font-weight: 650; }
.catalog-heading span { display: block; color: var(--bio-muted); font-size: 12px; margin-top: 5px; }
.catalog-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr)); column-gap: 26px; }
.catalog-app { position: relative; display: flex; align-items: center; gap: 12px; min-width: 0; padding: 14px 0; }
.catalog-app::after { content: ""; position: absolute; bottom: 0; left: 62px; right: 0; height: 1px; background: var(--bio-line); }
.catalog-icon { width: 50px; height: 50px; flex-shrink: 0; border-radius: 12px; background: #fff; border: 1px solid #00000012; display: flex; align-items: center; justify-content: center; overflow: hidden; }
.catalog-icon img { width: 100%; height: 100%; object-fit: contain; padding: 5px; }
.catalog-icon>i { color: #2878b7; font-size: 32px; }
.catalog-icon span { color: #0064d8; font-size: 18px; font-weight: 700; }
.catalog-copy { flex: 1; min-width: 0; }
.catalog-copy h3 { margin: 0; font-size: 14px; line-height: 1.3; font-weight: 600; overflow-wrap: anywhere; }
.catalog-copy p { margin: 4px 0 0; font-size: 11px; color: var(--bio-muted); line-height: 1.4; }
.catalog-visit { flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; min-width: 60px; min-height: 32px; border-radius: 20px; padding: 5px 12px; background: var(--bio-surface); color: var(--bio-blue); font-size: 12px; font-weight: 650; text-decoration: none; }
.catalog-visit:hover { background: var(--bio-bluewash); }
@media(max-width: 600px) { .tech-catalog { margin-top: 24px; }.catalog-grid { grid-template-columns: minmax(0, 1fr); }.catalog-visit { min-height: 44px; }.catalog-heading h2 { font-size: 19px; }.catalog-section + .catalog-section { margin-top: 26px; } }
</style>
